export const setToken = (token) => (dispatch) => {
  if (token) dispatch({ type: 'SET_TOKEN', payload: token })
}
